import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';

import { DprCardFilters } from '@dpr/models';
import { StaticMessage } from '@shared/enums';

@Component({
  selector: 'app-dpr-status-filter',
  templateUrl: './dpr-status-filter.component.html',
  styleUrls: ['./dpr-status-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DprStatusFilterComponent {
  @Input({ required: true }) isCompleted: boolean;
  @Input({ required: true }) isIncompleted: boolean;
  @Input({ required: true }) isLocked: boolean;
  @Input({ required: true }) isUnlocked: boolean;
  @Input({ required: true }) isSignedDprDetailsUploaded: boolean;
  @Input({ required: true }) isSignedDprDetailsNotUploaded: boolean;
  @Input({ required: true }) names: { [key: string]: string };

  @Output() selectionChanged = new EventEmitter<Partial<DprCardFilters>>();
  @Output() cancel = new EventEmitter();

  StaticMessage = StaticMessage;

  onApply(): void {
    this.applySelection();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onClear(): void {
    this.isCompleted = false;
    this.isIncompleted = false;
    this.isLocked = false;
    this.isUnlocked = false;
    this.isSignedDprDetailsNotUploaded = false;
    this.isSignedDprDetailsUploaded = false;

    this.applySelection();
  }

  private applySelection(): void {
    this.selectionChanged.emit({
      isCompleted: this.isCompleted,
      isIncompleted: this.isIncompleted,
      isLocked: this.isLocked,
      isUnlocked: this.isUnlocked,
      isSignedDprDetailsNotUploaded: this.isSignedDprDetailsNotUploaded,
      isSignedDprDetailsUploaded: this.isSignedDprDetailsUploaded,
    });
  }
}
